import React, { forwardRef, memo } from 'react';
import { 
  ReferenceLine as RechartReferenceLine,
  YAxis as RechartYAxis
} from 'recharts';

/**
 * Safe wrapper for ReferenceLine component that uses default parameters
 * instead of defaultProps to avoid React warnings and handles deprecated props.
 * Using memo and forwardRef to better isolate from the underlying component's warnings.
 */
export const ReferenceLine = memo(forwardRef(({ 
  alwaysShow,
  isFront = false,
  ifOverflow = 'none',
  x = undefined,
  y = undefined,
  segment = undefined,
  position = 'middle',
  ...props 
}, ref) => {
  // Handle deprecated alwaysShow prop
  if (alwaysShow !== undefined) {
    // If alwaysShow is true, convert it to the recommended ifOverflow="extendDomain"
    if (alwaysShow === true) {
      ifOverflow = 'extendDomain';
    }
  }

  return (
    <RechartReferenceLine
      ref={ref}
      isFront={isFront}
      ifOverflow={ifOverflow}
      x={x}
      y={y}
      segment={segment}
      position={position}
      {...props}
    />
  );
}));

/**
 * Safe wrapper for YAxis component that uses default parameters
 * instead of defaultProps to avoid React warnings.
 */
export const YAxis = memo(forwardRef(({
  allowDecimals = true,
  allowDataOverflow = false,
  allowDuplicatedCategory = true,
  hide = false,
  orientation = 'left',
  width = 60,
  height = 0,
  mirror = false,
  yAxisId = 0,
  tickCount = 5,
  type = 'number',
  padding = { top: 0, bottom: 0 },
  domain,
  scale = 'auto',
  ...props
}, ref) => {
  return (
    <RechartYAxis
      ref={ref}
      allowDecimals={allowDecimals}
      allowDataOverflow={allowDataOverflow}
      allowDuplicatedCategory={allowDuplicatedCategory}
      hide={hide}
      orientation={orientation}
      width={width}
      height={height}
      mirror={mirror}
      yAxisId={yAxisId}
      tickCount={tickCount}
      type={type}
      padding={padding}
      domain={domain}
      scale={scale}
      {...props}
    />
  );
}));